import React, { Component } from 'react'
import ActionButton from "../button/actionbutton.component.jsx"
import GlobalHelper from "../GlobalHelper.jsx";
import { injectIntl } from "react-intl";
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import EventBus from "../../common/EventBus.js";

class ExternalCheckoutContainer extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            onSubmit: this.props.onSubmit || function () { },

            submitDisabled: this.props.submitDisabled,
            submitButton: this.props.submitButton,
            submitButtonStyle: this.props.submitButtonStyle,
            integrationKey: this.props.integrationKey,
            currency: this.props.currency,
            amount: this.props.amount,
            proposalHash: this.props.proposalHash,
            contactId: this.props.contactId,
            variables: this.props.variables,

            proposalRefreshIntervalHandler: null,
            submitButtonLoading: false,
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.receiveLastPaymentTransaction = this.receiveLastPaymentTransaction.bind(this)
        EventBus.listen(EventBus.TopicPaymentTransactionCreated, 'external-checkout-container', this.receiveLastPaymentTransaction)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.amount !== this.props.amount){
            this.setState({
                amount: this.props.amount
            })
        }
    }

    receiveLastPaymentTransaction(event) {
        let variables = Object.assign({}, this.state.variables)
        variables.lastPayment = event.getData().payment
        this.setState({
            submitButtonLoading: false,
            variables: variables,
        })
    }

    getTransactions() {
        if (this.state.variables.document.type === 'account-statement') {
            return this.state.variables.customer.currentCustomerAccountTransactions.filter(t => t._type === 'invoices').map(t => {
                return {
                    amount: t.balance,
                    invoiceId: t.id,
                }
            })
        }
        const transaction = {
            amount: String(this.state.amount),
        }
        if (this.state.variables.document.type === 'invoice') {
            transaction.invoiceId = this.state.variables.quote.id
        }
        if (this.state.variables.document.type === 'quote') {
            transaction.quoteId = this.state.variables.quote.id
        }
        if (this.state.variables.document.type === 'order') {
            transaction.orderId = this.state.variables.quote.id
        }
        return [transaction]
    }

    pollForPendingPaymentUpdate() {
        if (!this.state.proposalRefreshIntervalHandler) {
            this.setState({
                proposalRefreshIntervalHandler: setInterval(() => {
                    AppContext.getApiClient().get('/proposals/' + this.state.proposalHash).then(res => {
                        this.setState({
                            variables: res.attributes.variables,
                        }, this.updatePaymentState)
                    })
                }, 2000)
            })
        }
    }

    updatePaymentState() {
        if (this.state.variables.lastPayment && this.state.variables.lastPayment.attributes.status !== 'pending') {
            EventBus.dispatch(EventBus.TopicProposalRefresh, {
                variables: this.state.variables,
            })
            clearInterval(this.state.proposalRefreshIntervalHandler)
            this.setState({
                submitButtonLoading: false,
                proposalRefreshIntervalHandler: null,
            })
        }
    }

    lastPaymentIsPending() {
        return this.state.variables.lastPayment &&
            this.state.variables.lastPayment.attributes.status === 'pending'
    }

    lastPendingPaymentTypeIsSameAsSelectedPaymentType() {
        this.lastPaymentIsPending() &&
            (this.state.variables.lastPayment.attributes.type === this.props.externalCheckoutPaymentType ||
                ['shopify', 'shopify-expert-app'].includes(this.state.integrationKey))
    }

    shouldOpenNewTab() {
        return false
        //return ['shopify', 'shopify-expert-app'].includes(this.state.integrationKey)
    }

    handleSubmit(event) {
        this.setState({ submitButtonLoading: true })
        event.preventDefault()

        this.submit()
    }

    submit() {
        const openNewTab = this.shouldOpenNewTab()

        if (this.state.variables.document.type === 'price-list' && !this.state.variables.lastPayment) {
            //the checkout section handles the polling
            EventBus.dispatch(
                EventBus.TopicCreateExternalCheckoutPaymentTransaction,
                { openNewTab: openNewTab },
            )
            return
        }

        //invoice url already exists and payment transaction is still pending so redirect there
        if (this.lastPendingPaymentTypeIsSameAsSelectedPaymentType()) {
            const externalLink = this.state.variables.lastPayment.attributes.externalLink
            if (externalLink.attributes.externalUrl) {

                if (this.state.variables.document.type !== 'price-list') {
                    AppContext.getApiClient().get('/proposals/' + this.state.proposalHash).then(res => {
                        this.setState({
                            variables: res.attributes.variables,
                        }, this.updatePaymentState)
                        if (res.attributes.variables.lastPayment.attributes.status !== 'pending') {
                            return
                        }

                        if (!openNewTab) {
                            window.location = externalLink.attributes.externalUrl
                            return
                        }

                        let tab = window.open(externalLink.attributes.externalUrl)
                        this.setState({ submitButtonLoading: false })

                        this.pollForPendingPaymentUpdate()
                    })
                } else {
                    if (!openNewTab) {
                        window.location = externalLink.attributes.externalUrl
                        return
                    }

                    let tab = window.open(externalLink.attributes.externalUrl)
                    this.setState({ submitButtonLoading: false })
                }

            }

            return
        }

        const data = {
            paymentType: this.props.externalCheckoutPaymentType || 'credit-card',
            currency: this.state.currency,
            contactId: this.state.contactId,
            source: 'online',
            transactions: this.getTransactions(),
            fingerprintId: GlobalHelper.getFingerprintId(),
            integrationKey: this.state.integrationKey,
            externalCheckout: {
                source: 'online',
                locationId: this.state.variables.quote.locationId
            }
        }

        AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/payment-transactions', data).then(res => {
            this.setState({
                error: '',
            })

            if (!res.error) {
                const lastPayment = res.attributes.variables.lastPayment
                if (lastPayment.attributes.externalLink) {
                    EventBus.dispatch(EventBus.TopicProposalRefresh, {
                        variables: res.attributes.variables,
                    })

                    if (!openNewTab) {
                        window.location = lastPayment.attributes.externalLink.attributes.externalUrl
                        return
                    }

                    let tab = window.open(lastPayment.attributes.externalLink.attributes.externalUrl)
                    this.setState({
                        variables: res.attributes.variables,
                        submitButtonLoading: false,
                    }, this.pollForPendingPaymentUpdate())
                }
            } else {
                this.setState({
                    submitButtonLoading: false,
                    error: res.error.message,
                })
            }
        })
    }


    render() {
        return <div>
            <ActionButton
                className="btn btn-primary w-100"
                style={this.state.submitButtonStyle}
                onClick={this.handleSubmit}
                isLoading={this.state.submitButtonLoading}
            >
                {this.state.submitButton}
            </ActionButton>
            {
                this.state.error &&
                <small className="text-danger">{this.state.error}</small>
            }
        </div>
    }
}

export default injectIntl(ExternalCheckoutContainer)





// WEBPACK FOOTER //
// ./src/common/external-checkout/externalcheckoutcontainer.component.jsx